import React, { useEffect, useState } from "react";
import "../../Dashboard/Dashboard.css";
import "../../Dashboard/Sidebar.js";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
import DashboardMenu from "../../layout/dashboardMenu";
import Loader from "../../../Loader/Loader";

const BusinessConfigInspection = ({
    history,
    match,
    viewInspectionForm,
    inspectionForm
}) => {

    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [userMessage, setUserMessage] = useState('')
    const [redirectUrl, setRedirectUrl] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await viewInspectionForm(match.params.id);
            setIsLoading(false);
        })();
    }, [match.params.id]);

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={userMessage}
                url={redirectUrl}
            />
            <FailedModal
                isOpen={isFailedModalOpen}
                msg={userMessage}
                countToOpenModal={countToOpenModal}
            />

            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading} />
            <div id="wrapper">
                <DashboardMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={match?.params?.id !== undefined ? "Inspection Form" : "Add Lead"}
                        />
                        {/*BODY*/}

                        <div className="container-fluid">
                            {/*Heading*/}

                            <form>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="div-com-header">
                                            </div>
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.model &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.model}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Model
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.year_of_manufacture &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.year_of_manufacture}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Year of Manufacture
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.date_of_purchase &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.date_of_purchase}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Date of Purchase
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.spare_available &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.spare_available}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Spare Available
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.amc_scope &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.amc_scope}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - AMC Scope
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.lcm_ocm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.lcm_ocm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - LCM OCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.recommend_lcm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.recommend_lcm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Recommend LCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.foundation_status &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.foundation_status}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Foundation Status
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.foundation_required &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.foundation_required}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Foundation Required
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.motor_control_card_functionality &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.motor_control_card_functionality}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Motor Control Card Functionality
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.motor_control_card_required &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.motor_control_card_required}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Motor Control Card Required
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.arm_status &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.arm_status}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Arm Status
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.arm_required &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.arm_required}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Arm Required
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.safety_available &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.safety_available}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Safety Available
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.loop_photocell_required &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.loop_photocell_required}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Loop photocell required
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.any_abnormal_sound &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.any_abnormal_sound}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Any abnormal sound
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.abnormal_sound &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.barrier?.abnormal_sound}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Barrier - Abnormal Sound
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.barrier && inspectionForm?.barrier?.file_path &&
                                                            <div className="col-md-6 float-field ">
                                                                <p className="large-label float-lb ">Barrier Attachments
                                                                    {inspectionForm?.barrier?.file_path.map((elem, ind) => { return (<div key={ind}><i className="fas fa-paperclip"></i><a href={elem}>{` Attachment ${ind + 1}`}</a></div>) })}
                                                                </p>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.model &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.model}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - Model
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.year_of_manufacture &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.year_of_manufacture}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - Year of Manufacture
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.date_of_purchase &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.date_of_purchase}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - Date of Purchase
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.spare_available &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.spare_available}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - Spare Available
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.amc_scope &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.amc_scope}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - AMC Scope
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.lcm_ocm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.lcm_ocm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - LCM OCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.recommend_lcm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.recommend_lcm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - Recommend LCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.reader_available &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.reader_available}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - Reader Available
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.reader_available_recommend &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.reader_available_recommend}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - Reader Available Recommend
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.pcb_replacement_feasible &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.pcb_replacement_feasible}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - PCB Replacement Feasible
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.pcb_replacement_feasible_recommend &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.pcb_replacement_feasible_recommend}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - PCB Replacement Feasible Recommend
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.type_of_antenna &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.type_of_antenna}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - Type of Antenna
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.type_of_antenna_recommend &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.reader?.type_of_antenna_recommend}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reader - Type of Antenna Recommend
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.reader && inspectionForm?.reader?.file_path &&
                                                            <div className="col-md-6 float-field ">
                                                                <p className="large-label float-lb ">Reader Attachments
                                                                    {inspectionForm?.reader?.file_path.map((elem, ind) => { return (<div key={ind}><i className="fas fa-paperclip"></i><a href={elem}>{` Attachment ${ind + 1}`}</a></div>) })}
                                                                </p>
                                                            </div>

                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.model &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.model}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Model
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.year_of_manufacture &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.year_of_manufacture}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Year of Manufacture
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.date_of_purchase &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.date_of_purchase}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Date of Purchase
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.spare_available &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.spare_available}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Spare Available
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.amc_scope &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.amc_scope}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - AMC Scope
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.lcm_ocm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.lcm_ocm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - LCM OCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.recommend_lcm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.recommend_lcm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Recommend LCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.recommend_lcm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.recommend_lcm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Recommend LCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.printer_integration &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.printer_integration}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Printer Integration
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.printer_integration_recommend &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.printer_integration_recommend}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Printer Integration Recommend
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.cabinate_condition &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.cabinate_condition}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Cabinate Condition
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.cabinate_condition_recommend &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.cabinate_condition_recommend}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Cabinate Condition Recommend
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.power_control_install &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.power_control_install}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Power Control Install
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.power_control_install_recommend &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.tvm?.power_control_install_recommend}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    TVM - Power Control Install Recommend
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.tvm && inspectionForm?.tvm?.file_path &&
                                                            <div className="col-md-6 float-field ">
                                                                <p className="large-label float-lb ">TVM Attachments
                                                                    {inspectionForm?.tvm?.file_path.map((elem, ind) => { return (<div key={ind}><i className="fas fa-paperclip"></i><a href={elem}>{` Attachment ${ind + 1}`}</a></div>) })}
                                                                </p>
                                                            </div>
                                                        }
                                                        {inspectionForm?.led && inspectionForm?.led?.model &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.led?.model}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    LED - Model
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.led && inspectionForm?.led?.year_of_manufacture &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.led?.year_of_manufacture}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    LED - Year of Manufacture
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.led && inspectionForm?.led?.date_of_purchase &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.led?.date_of_purchase}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    LED - Date of Purchase
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.led && inspectionForm?.led?.spare_available &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.led?.spare_available}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    LED - Spare Available
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.led && inspectionForm?.led?.amc_scope &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.led?.amc_scope}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    LED - AMC Scope
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.led && inspectionForm?.led?.lcm_ocm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.led?.lcm_ocm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    LED - LCM OCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.led && inspectionForm?.led?.recommend_lcm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.led?.recommend_lcm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    LED - Recommend LCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.led && inspectionForm?.led?.feedback_recommend_tech_team &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.led?.feedback_recommend_tech_team}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    LED - Recommendation from Tech Team
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.led && inspectionForm?.led?.file_path &&
                                                            <div className="col-md-6 float-field ">
                                                                <p className="large-label float-lb ">LED Attachments
                                                                    {inspectionForm?.led?.file_path.map((elem, ind) => { return (<div key={ind}><i className="fas fa-paperclip"></i><a href={elem}>{` Attachment ${ind + 1}`}</a></div>) })}
                                                                </p>
                                                            </div>
                                                        }
                                                        {inspectionForm?.anpr && inspectionForm?.anpr?.model &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.anpr?.model}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    ANPR - Model
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.anpr && inspectionForm?.anpr?.year_of_manufacture &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.anpr?.year_of_manufacture}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    ANPR - Year of Manufacture
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.anpr && inspectionForm?.anpr?.date_of_purchase &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.anpr?.date_of_purchase}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    ANPR - Date of Purchase
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.anpr && inspectionForm?.anpr?.spare_available &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.anpr?.spare_available}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    ANPR - Spare Available
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.anpr && inspectionForm?.anpr?.amc_scope &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.anpr?.amc_scope}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    ANPR - AMC Scope
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.anpr && inspectionForm?.anpr?.lcm_ocm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.anpr?.lcm_ocm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    ANPR - LCM OCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.anpr && inspectionForm?.anpr?.recommend_lcm &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.anpr?.recommend_lcm}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    ANPR - Recommend LCM
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.anpr && inspectionForm?.anpr?.feedback_recommend_tech_team &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.anpr?.feedback_recommend_tech_team}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    ANPR - Recommendation from Tech Team
                                                                </label>
                                                            </div>
                                                        }
                                                        {inspectionForm?.anpr && inspectionForm?.anpr?.file_path &&
                                                            <div className="col-md-6 float-field ">
                                                                <p className="large-label float-lb ">ANPR Attachments
                                                                    {inspectionForm?.anpr?.file_path.map((elem, ind) => { return (<div key={ind}><i className="fas fa-paperclip"></i><a href={elem}>{` Attachment ${ind + 1}`}</a></div>) })}
                                                                </p>
                                                            </div>
                                                        }
                                                        {inspectionForm?.remarks &&
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    disabled
                                                                    required
                                                                    value={inspectionForm?.remarks}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Remarks
                                                                </label>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <BottomMenu />
            </div>
            {/* section ends */}
        </>
    )
}
export default BusinessConfigInspection